var CoreModule = /** @class */ (function () {
    function CoreModule() {
    }
    return CoreModule;
}());
export { CoreModule };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/shared/core/core.module.ts.pre-build-optimizer.js